import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Modal, Select} from "antd";
import {API} from "../../../../http";
import {NEW_ENDPOINTS} from "../../../../http/endpoints";
import {FIELDS_SCHEME, GENERAL_SCHEME} from "../../../../schemas";
import {fetchTariffs, fetchUsers} from "../../../../actions/users";

const CreateUserModal = ({open, onClose, onSubmit, ...props}) => {
  const [loading, setLoading] = useState(false);
  const [tariffs, setTariffs] = useState([]);

  const [form] = Form.useForm();

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await API.post(NEW_ENDPOINTS.ADMIN.USER.CREATE, values);
      message.success('User created successfully');
      onClose();
      onSubmit?.(values);
    } catch (error) {
      message.error('Failed to create user');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoading(true);
      try {
        const tariffs = await fetchTariffs();
        setTariffs(tariffs);
      } finally {
        setLoading(false);
      }
    }
    if (open) fetchInitialData();
  }, [open]);


  return (
    <Modal
      title="Create New User"
      open={open}
      okButtonProps={{
        loading: loading,
        type: 'primary',
        shape: 'round',
        size: 'large',
      }}
      cancelButtonProps={{
        size: 'large',
        shape: 'round',
      }}
      onOk={form.submit}
      okText="Create user"
      onCancel={onClose}
      destroyOnClose
      {...props}
    >
      <Form
        form={form}
        variant="filled"
        size="large"
        preserve={false}
        labelAlign="left"
        labelCol={{ span: 6 }}
        onFinish={handleFinish}
      >
        <Form.Item
          name="uid"
          label="UID"
          rules={[...GENERAL_SCHEME.required, ...GENERAL_SCHEME.alphaNumeric]}
        >
          <Input placeholder="ID" />
        </Form.Item>
        <Form.Item
          name="first_name"
          label="First Name"
          rules={[...GENERAL_SCHEME.required, ...FIELDS_SCHEME.name]}
        >
          <Input placeholder="First name" />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="Last Name"
          rules={[...GENERAL_SCHEME.required, ...FIELDS_SCHEME.name]}
        >
          <Input placeholder="Last name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[...GENERAL_SCHEME.required, ...FIELDS_SCHEME.email]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="tariff" label="Tariff" rules={GENERAL_SCHEME.required}>
          <Select className="w100">
            {tariffs.map(item => (
              <Select.Option value={item.id}>{item.name || item.id}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="risk_level"
          label="Risk Level"
          rules={GENERAL_SCHEME.required}
        >
          <Select style={{ width: 120 }}>
            <Select.Option value={0}>0</Select.Option>
            <Select.Option value={1}>1</Select.Option>
            <Select.Option value={2}>2</Select.Option>
            <Select.Option value={3}>3</Select.Option>
            <Select.Option value={4}>4</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateUserModal;
